<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="company_name"
            label="公司名称">
          </el-table-column>
          <el-table-column
            prop="cert_company"
            label="证书抬头">
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="姓名">
          </el-table-column>
          <el-table-column
            prop="order_id"
            label="委托单号">
          </el-table-column>
          <el-table-column
            prop="amount"
            label="数量">
          </el-table-column>
          <el-table-column
            prop="create_date"
            label="创建日期">
          </el-table-column>
          <el-table-column label="操作" >
            <template slot-scope="scope">
              <el-button
                class="detail-btn"
                @click="handleApply(scope.row)"
                >
                详情
                </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script type='text/ecmascript-6'>
export default {
  data () {
    return {
      empty: '没有已领订单！',
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      sendShow: false,
      orderDetail: {},
      orderIndex: ''
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    initData () { // 初始化页面 发送 订单ID 获取订单详情
      let that = this
      that.loading = true
      this.$api.myZcOrder({
      }).then(res => {
        that.loading = false
        if (res.data.length > 0) {
          that.tableData = res.data
        } else {
          that.tableData = []
        }
      }).catch(err => {
        this.$message({
          message: err,
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      this.initData()
    },
    handleApply (row) { // 点击详情
      this.orderDetail = row
      this.$router.push({
        path: '/newOrderDetail',
        query: { order_id: row.order_id}
      })
    }
  },
  components: {
  },
  watch: {
    /* '$router': 'initData' */
  }
}
</script>

<style  lang='stylus' rel='stylesheet/stylus'>
</style>
